import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NewPasswordContainer from '../new-password/NewPasswordContainer';
import WorkflowNavContainer from '../workflow-navigation/WorkflowNavContainer';
import PasswordRevealWithoutForwardedType from '../new-password/PasswordRevealWithoutForwardedType';
import { DebounceInput } from 'react-debounce-input';

const propTypes = {
    workflowNavElementId: PropTypes.string,
    validatePasswordUrl: PropTypes.string,
    secondaryButtonUrl: PropTypes.string
};

class ChangePasswordContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passwordIsValid: false
        };
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
    }

    handlePasswordChange(isValid) {
        this.setState({ passwordIsValid: isValid });
    }

    isNextEnabled() {
        return this.state.passwordIsValid;
    }

    noop() {}

    render() {
        const { validatePasswordUrl } = this.props;

        return (
            <div>
                <DebounceInput
                    element={PasswordRevealWithoutForwardedType}
                    onChange={this.noop}
                    debounceTimeout={700}
                    placeholder="Password"
                    id="currentPassword"
                    name="currentPassword"
                    label="Current Password"
                    subtext="If you don't remember your password, you can log out, and then click 'Forgot Password' when asked to enter it."
                    isNewPassword
                    isRequired
                />
                <NewPasswordContainer
                    validateUrl={validatePasswordUrl}
                    onChange={this.handlePasswordChange}
                    isRegistered
                />
                <WorkflowNavContainer
                    primaryButtonSubmitEnabled={this.isNextEnabled()}
                    primaryButtonText="Change Password"
                    elementId={this.props.workflowNavElementId}
                    secondaryButtonUrl={this.props.secondaryButtonUrl}
                    secondaryButtonText="Cancel"
                />
            </div>
        );
    }
}

ChangePasswordContainer.propTypes = propTypes;
export default ChangePasswordContainer;
